import React from "react";
import PropTypes from "prop-types";
import FeaturedImage from "../FeaturedImage";
import useSettingsContext from "../../context/useSettingsContext";
import useDataContext from "../../context/useDataContext";
import { checkCurrency } from "../../methods/utilities/checkCurrency";

function Tour(props) {
    const { post } = props;
    const { postType } = useSettingsContext();
    let featuredImage;
    let preHeading;
    const heading = post.acf.h_title || post.title.rendered;
    let price;
    let reviews;

    const { globalData } = useDataContext();

    const currentCurrency = checkCurrency(globalData["data_currency"]);

    Tour.propTypes = {
        post: PropTypes.object,
    };

    if (post.featured_image !== undefined && post.featured_image) {
        featuredImage = (
            <FeaturedImage
                imageSize={"thumbnail-content-image"}
                image={post.featured_image}
                srcset={post.featured_image}
            ></FeaturedImage>
        );
    }

    if (post.acf.h_pre_header) {
        preHeading = (
            <figcaption className="tour-card__caption">
                <i className="icon-label"></i>
                {post.acf.h_pre_header}
            </figcaption>
        );
    }

    if (post.eight29_custom.all_price) {
        let prices = [];
        for (let [key, value] of Object.entries(
            post.eight29_custom.all_price
        )) {
            prices.push(
                <b
                    className="tour-card__price-value"
                    currency={key.toUpperCase()}
                    default={key === post.acf.tour_price_currency}
                    key={key}
                    dangerouslySetInnerHTML={{
                        __html: value,
                    }}
                />
            );
        }
        price = (
            <div className="tour-card__price">
                <p className="tour-card__price-text">
                    From
                    {prices}
                </p>
            </div>
        );
    }

    if (post.acf.ventrata_reservation_code) {
        reviews = (
            <div className="tour-card__yotpo">
                <div
                    className="yotpo bottomLine yotpo-small"
                    data-product-id={post.acf.ventrata_reservation_code}
                ></div>
            </div>
        );
    }

    return (
        <article
            id={`${postType}-${post.id}`}
            className="tour-card eight29-post-tour"
        >
            <div className="tour-card__wrapper">
                <a href={post.link} className="tour-card__link">
                    <figure className="tour-card__img">
                        <div className="image-decorator">{featuredImage}</div>
                        {preHeading}
                    </figure>
                </a>

                <div className="tour-card__content">
                    <h3 className="tour-card__heading">
                        <a
                            href={post.link}
                            dangerouslySetInnerHTML={{ __html: heading }}
                            className="tour-card__heading-link"
                        ></a>
                    </h3>
                    {reviews}
                    {price}
                </div>
            </div>
        </article>
    );
}

export default Tour;
